import { useEffect, useState } from 'react';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../firebase';

interface AdminAuthState {
  user: User | null;
  isPlatformAdmin: boolean;
  loading: boolean;
}

const OCTOPM_DOMAIN = '@octo.pm';

export function useAdminAuth(): AdminAuthState {
  const [state, setState] = useState<AdminAuthState>({
    user: null,
    isPlatformAdmin: false,
    loading: true,
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ user: null, isPlatformAdmin: false, loading: false });
        return;
      }

      // Client-side domain check (UX gate only — server enforces authoritatively)
      const isOctopmEmail = user.email?.endsWith(OCTOPM_DOMAIN) ?? false;

      // Check platformAdmin claim from token
      const tokenResult = await user.getIdTokenResult();
      const hasClaim = tokenResult.claims['platformAdmin'] === true;

      setState({
        user,
        isPlatformAdmin: isOctopmEmail && hasClaim,
        loading: false,
      });
    });

    return unsubscribe;
  }, []);

  return state;
}
